import { Component  } from 'react';
import VisibilityIcon from "@material-ui/icons/Visibility";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  saveNewApiKey,
  listClientApiKeys,
  deleteApiKey,
} from "../../../config/client_api_calls";
import $ from "jquery";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "../../../config/helperClass";
import { APP_LIVE_URL } from "../../../config/config";
import MutextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/FormLoader";

const auth = new HelperClass();

class ApiKey extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      tableDataSingle: [],
      serviceData: [],
      tableLoaderListing: true,
      tableLoader: true,
      errorMessage: "",
      successMessage: "",
      errorMessageDelete: "",
      successMessageDelte: "",
      key_name: "",
      domain_name: "",
      api_key: "",
      apiCopied: false,
      api_key_id: "",
      copiedIndex: null,

      columnServices: [
        {
          name: "Key Name",
        },
        {
          name: "Domain Name",
          options: {
            customBodyRender: (value, tableMeta) => {
              const index = tableMeta.rowIndex;
              const isCopied = this.state.copiedIndex === index;

              const handleCopy = () => {
                navigator.clipboard.writeText(value);
                this.setState({ copiedIndex: index });
                setTimeout(() => this.setState({ copiedIndex: null }), 2000);
              };

              return (
                <div className="d-flex align-items-center">
                  <span>{value}</span>
                  <Tooltip
                    title={isCopied ? "Copied!" : "Copy"}
                    placement="top"
                  >
                    <a
                      style={{ cursor: "pointer" }}
                      className="ml-2"
                      onClick={handleCopy}
                    >
                      <em
                        className={`icon ni ${
                          isCopied ? "ni-check-circle-fill" : "ni-copy"
                        }`}
                        style={{ color: "black" }}
                      ></em>
                    </a>
                  </Tooltip>
                </div>
              );
            },
          },
        },
        {
          name: "Key",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{value.substring(0, 24)}...</div>;
            },
          },
        },
        {
          name: "Date",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.formatDateTime(value)}</div>;
            },
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>
                  <div
                    className="nk-tb-col nk-tb-col-tools"
                    style={{ padding: "0px" }}
                  >
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <div className="drodown">
                          <a
                            href="#"
                            title="Other Actions"
                            className="dropdown-toggle btn btn-icon  btn-outline-light"
                            data-toggle="dropdown"
                          >
                            <em className="icon ni ni-more-h"></em>
                          </a>
                          <div className="dropdown-menu dropdown-menu-right">
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    this.deleteApiKeyFun(value, tableMeta)
                                  }
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Delete Api Key"
                                  disabled={
                                    this.props.is_msa_signed === "No" ||
                                    this.props.defaultSettings === "missing"
                                      ? true
                                      : false
                                  }
                                >
                                  <em className="icon ni ni-trash"></em>
                                  <span>Delete Api Key</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            },
          },
        },
      ],
    };
  }

  async componentDidMount() {
    const servicesResponce = await listClientApiKeys(
      auth.getClientAccount(),
      auth.getClientToken()
    );
    // console.log("Available Client Api Keys: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
      //window.location.replace("/error");
    }
  }

  setStatus = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === "pending") {
      return (
        <div>
          <span className="badge badge-outline-warning">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> Pending
          </span>
        </div>
      );
    } else if (domain_str === "approved") {
      return (
        <div>
          <span className="badge badge-outline-secondary">
            {" "}
            <em className="icon ni ni-done "></em> Approved
          </span>
        </div>
      );
    } else if (domain_str === "rejected") {
      return (
        <div>
          <span className="badge badge-outline-danger">
            {" "}
            <em className="icon ni ni-alert-c"></em> Rejected
          </span>
        </div>
      );
    }
  };

  setComplete = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === "incomplete") {
      return (
        <div>
          <span className="badge badge-outline-warning">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> In Progress
          </span>
        </div>
      );
    } else if (domain_str === "complete") {
      return (
        <div>
          <span className="badge badge-outline-secondary">
            {" "}
            <em className="icon ni ni-done "></em> Submitted
          </span>
        </div>
      );
    }
  };

  viewPdf = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str && domain_str !== "") {
      return (
        <div>
          <a
            onClick={() => this.downloadPdf(value)}
            style={{ cursor: "pointer" }}
            title="Download PDF"
          >
            <span className="badge badge-outline-secondary">
              {" "}
              <em className="icon ni ni-file-pdf"></em> View PDF
            </span>
          </a>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-outline-light">
            {" "}
            <em className="icon ni ni-file-pdf"></em> View PDF
          </span>
        </div>
      );
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  downloadPdf = async (d_f_name) => {
    var url = APP_LIVE_URL + "files_data/credit_application/" + d_f_name;
    let file_name = d_f_name;
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = file_name;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  };

  handleChanges = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangeCheckbox = (input) => (e) => {
    this.setState({
      [input]:
        e.target.type === "checkbox" ? e.target.checked : e.target.checked,
    });
    //console.log("handleChangeCheckbox: ", input);
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  generateRandomNumber = (link) => {
    const min = 1000000000; // Minimum 10-digit number (10^9)
    const max = 9999999999; // Maximum 10-digit number (10^10 - 1)
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    this.props.props.history.push(link + "/" + randomNumber);
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  setNewApiKeySettings = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
      key_name: "",
    });
    window.$("#modalAddNewApiKey").modal("show");
  };

  modalHideDel = () => {
    window.$("#modalAddNewApiKey").modal("hide");
  };

  saveNewApiKey = async () => {
    const { key_name } = this.state;
    this.setState({
      errorMessage: "",
      successMessage: "",
      disabled: true,
    });

    if (key_name === "") {
      this.setState({
        errorMessage: "Please enter the key name.",
        successMessage: "",
        disabled: false,
      });
    } else {
      const servicesResponce = await saveNewApiKey(
        auth.getClientAccount(),
        auth.getClientToken(),
        key_name
      );

      // console.log("agentsResponce.data.data: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 409) {
        this.setState({
          errorMessage: "API Key with the same name already exists.",
          successMessage: "",
          disabled: false,
        });
      } else if (
        servicesResponce.data.status === 429 &&
        servicesResponce.data.message === "API Key limit reached."
      ) {
        this.setState({
          errorMessage:
            "API Key limit reached. You can only create up to 100 keys.",
          successMessage: "",
          disabled: false,
        });
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          errorMessage: "There is some error while creating a api key.",
          successMessage: "",
          disabled: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "API Key created successfully"
      ) {
        this.setState({
          errorMessage: "",
          successMessage: "API Key created successfully",
          disabled: false,
          key_name: "",
          api_key: servicesResponce.data.apiKey,
        });

        setTimeout(() => {
          window.$("#modalAddNewApiKey").modal("hide");
        }, 3000);

        setTimeout(() => {
          window.$("#modalShowApiKey").modal("show");
          this.getClientApiKeys();
        }, 3200);
      } else {
        this.setState({
          errorMessage: "There is some error while creating a api key.",
          successMessage: "",
          disabled: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({
        clientErrorMessage: "",
        clientSuccessMessage: "",
      });
    }, 4000);
  };

  formatDateTime(dateString) {
    if (!dateString || isNaN(Date.parse(dateString))) {
      return "Invalid Date";
    }

    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };

    return new Date(dateString).toLocaleString("en-US", options);
  }

  getClientApiKeys = async () => {
    const servicesResponce = await listClientApiKeys(
      auth.getClientAccount(),
      auth.getClientToken()
    );
    // console.log("Available Client Api Keys: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        tableData: [],
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableData: [],
        tableLoader: false,
        tableLoaderListing: false,
      });
      //window.location.replace("/error");
    }
  };

  copyApiKeyToClipboard = () => {
    const input = document.getElementById("copyApiKeyInput");
    input.select();
    input.setSelectionRange(0, 99999); // For mobile devices
    document.execCommand("copy");
    this.setState({ apiCopied: true });

    setTimeout(() => {
      this.setState({ apiCopied: false });
    }, 2000);
  };

  deleteApiKeyFun = (value, tableMeta) => {
    let api_key_id = tableMeta.rowData[4];
    this.setState({
      api_key_id: api_key_id,
      errorMessageDelete: "",
      successMessageDelte: "",
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  deleteApiKey = async () => {
    this.setState({ isProcessing: true });
    let api_key_id = this.state.api_key_id;
    const servicesResponse = await deleteApiKey(
      auth.getClientAccount(),
      auth.getClientToken(),
      api_key_id
    );

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "API Key deleted successfully."
    ) {
      this.setState({
        successMessageDelte: "API Key deleted successfully.",
        isProcessing: false,
      });
      setTimeout(() => {
        window.$("#modalDeleteAlert").modal("hide");
        this.getClientApiKeys();
      }, 3200);
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        errorMessageDelete: "Error api key not found.",
      });
    } else {
      this.setState({
        errorMessageDelete: "Error failed to delete api key.",
      });
    }
  };

  modalHideDelete = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  render() {
    const { step } = this.state;
    const { email, VerifyUsernameButton } = this.state;
    const values = {
      email,
      VerifyUsernameButton,
    };
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div className="nk-content " id="Support_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}
          {/* MSA WARNING END */}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Api Keys" icon="icon ni ni-setting" />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            {this.props.defaultSettings !== "missing" ? (
                              <a
                                onClick={() => this.setNewApiKeySettings()}
                                style={{
                                  color: "#fff",
                                }}
                                className="btn btn-primary"
                              >
                                <em className="icon ni ni-plus-round"></em>
                                <span>Create Api Key</span>
                              </a>
                            ) : null}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          {this.state.tableLoader === true ? (
                            TableLoader()
                          ) : (
                            <DataTableExtended
                              columns={this.state.columnServices}
                              tableData={this.state.tableData}
                              title=""
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                  {/* New Client Modal Start */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalAddNewApiKey"
                  >
                    <div
                      className="modal-dialog modal-dialog-top modal-xl"
                      role="document"
                    >
                      <div className="modal-content">
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-header">
                          <h5 className="modal-title">
                            <em
                              className="icon ni ni-setting"
                              style={{ marginRight: "15px" }}
                            ></em>{" "}
                            Create a new Api Key
                          </h5>
                        </div>
                        <div className="modal-body">
                          {this.state.formLoader === true ? (
                            FormLoader()
                          ) : (
                            <div className="row g-4">
                              {this.state.errorMessage !== "" ? (
                                <div className="col-md-12 mb-1">
                                  <div
                                    className="example-alert example-alert-revoke"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>{this.state.errorMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.successMessage !== "" ? (
                                <div className="col-md-12 mb-1">
                                  <div
                                    className="example-alert example-alert-revoke"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>{this.state.successMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              <div className="col-md-12">
                                <div className="form-group">
                                  <div className="form-control-group">
                                    <label
                                      htmlFor="key_name"
                                      className="form-label"
                                    >
                                      Key Name *
                                    </label>
                                    <MutextField
                                      required
                                      id="key_name"
                                      name="key_name"
                                      type="text"
                                      label=""
                                      value={this.state.key_name}
                                      inputProps={{ maxLength: 64 }}
                                      helperText=""
                                      onChange={this.handleChanges}
                                      variant="outlined"
                                      fullWidth
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <div className="form-control-group">
                                    <label
                                      htmlFor="key_name"
                                      className="form-label"
                                    >
                                      Domain Name
                                    </label>
                                    <MutextField
                                      required
                                      id="domain_name"
                                      name="domain_name"
                                      type="text"
                                      label=""
                                      defaultValue={auth.getDomainNameClient()}
                                      helperText=""
                                      inputProps={{ maxLength: 100 }}
                                      onChange={this.handleChanges}
                                      variant="outlined"
                                      fullWidth
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12 d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => this.modalHideDel()}
                                  className="btn btn-lg btn-danger mr-2"
                                  disabled={this.state.disabled}
                                >
                                  <span>Cancel</span>{" "}
                                </button>
                                <button
                                  type="button"
                                  onClick={() => this.saveNewApiKey()}
                                  className="btn btn-lg btn-primary"
                                  disabled={this.state.disabled}
                                >
                                  <span>Create</span>{" "}
                                </button>
                              </div>
                              <div className="col-md-12">
                                <div className="example-alert">
                                  <div className="alert alert-light">
                                    <ul className="list">
                                      <li>
                                        We don't version the OnBoardSoft API. We
                                        rarely change API endpoints, and almost
                                        never remove them, but if you write code
                                        that relies on the API, there's a chance
                                        you might have to update your code in
                                        the future.
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* New Client Modal End */}
                  {/* New Api Copy Modal Start */}
                  <div
                    className="modal fade"
                    id="modalShowApiKey"
                    tabIndex="-1"
                    role="dialog"
                  >
                    <div
                      className="modal-dialog modal-dialog-centered modal-lg"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">
                            Copy and save the API key
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              border: "none",
                              background: "transparent",
                            }}
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <label className="form-label">The API key</label>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.api_key}
                              readOnly
                              id="copyApiKeyInput"
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={() => this.copyApiKeyToClipboard()}
                              >
                                {this.state.apiCopied ? (
                                  "Copied!"
                                ) : (
                                  <em className="icon ni ni-copy"></em>
                                )}
                              </button>
                            </div>
                          </div>
                          <small className="text-muted d-block mt-2">
                            Please copy this key and save it somewhere safe. For
                            security reasons, we can’t show it to you again.
                          </small>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-primary"
                            data-dismiss="modal"
                          >
                            Done
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* New Api Copy Modal End */}
                  {/* START DELETE MODAL  */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalDeleteAlert"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <a
                          style={{ cursor: "pointer" }}
                          className="close"
                          onClick={() => {
                            this.modalHideDelete();
                          }}
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-body modal-body-lg text-center">
                          <div className="nk-modal">
                            <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                            <h4 className="nk-modal-title">Delete Api Key?</h4>

                            <div className="nk-modal-text">
                              {this.state.errorMessageDelete !== "" ? (
                                <div
                                  className="example-alert"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-danger">
                                    <div className="alert-text">
                                      <h4>Error</h4>
                                      <p>{this.state.errorMessageDelete}</p>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.successMessageDelte !== "" ? (
                                <div
                                  className="example-alert"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-success">
                                    <div className="alert-text">
                                      <h4>Success</h4>
                                      <p>{this.state.successMessageDelte}</p>
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              <div className="caption-text">
                                You won't be able to recover a deleted API key.
                                You'll have to create a new key.
                              </div>
                            </div>
                            <div className="nk-modal-action">
                              <a
                                style={{ cursor: "pointer", color: "white" }}
                                className="btn btn-lg btn-mw btn-primary"
                                onClick={() => {
                                  this.modalHideDelete();
                                }}
                              >
                                CANCEL
                              </a>
                              {"  "}
                              <a
                                style={{ cursor: "pointer", color: "white" }}
                                className="btn btn-lg btn-mw btn-danger"
                                onClick={() => {
                                  this.deleteApiKey();
                                }}
                                disabled={
                                  this.state.disabled || this.state.isProcessing
                                } // disable button when processing
                              >
                                {this.state.isProcessing ? (
                                  <span>DELETING...</span>
                                ) : (
                                  <span>DELETE</span>
                                )}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* END DELETE MODAL  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ApiKey);
